// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"bb36780b","112":"a28003da","307":"de310329","332":"8df03bda","453":"756455db","516":"bd8ae523","538":"f5e8a8a6","562":"dba9d479","635":"0e34065b"}[chunkId] + ".chunk.js";
};